module.exports = __webpack_public_path__ + "static/media/BESS-image-SE.72dd8254.png";